import { TFunction } from 'i18next';
import {
  CalculatorIcon,
  FoodIcon,
  HammerIcon,
  PhoneRepairIcon,
  PipeIcon,
  StoreFrontIcon,
} from '@/shared/ui';

const icons = [HammerIcon, PhoneRepairIcon, FoodIcon, StoreFrontIcon, PipeIcon, CalculatorIcon];

export const getWhoIsThisForList = (t: TFunction) => {
  const list = t('mainPage.whoIsThisFor.list', { returnObjects: true }) as Array<{
    heading: string;
    description: string;
  }>;

  return list.map((item, index) => ({
    ...item,
    Icon: icons[index]!,
  }));
};
